import { render, staticRenderFns } from "./SidebarEditor.vue?vue&type=template&id=c7387e72&scoped=true"
import script from "./SidebarEditor.vue?vue&type=script&lang=js"
export * from "./SidebarEditor.vue?vue&type=script&lang=js"
import style0 from "./SidebarEditor.vue?vue&type=style&index=0&id=c7387e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7387e72",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIEditorTextEditor: require('/opt/atlassian/pipelines/agent/build/components/UI/Editor/TextEditor.vue').default})
